import React, { useState } from 'react'
import CValidator from '../CValidator';
import { Form } from "react-bootstrap"
import { TextField } from '@fluentui/react/lib/TextField';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../common/Helpers';

function CTextAreaSimple(props) {

    //Parametros de entrada.
    const inputParam_LabelText = props.labelText;
    const inputParam_ControlValue = !isNullUndefinedOrEmpty(props.controlValue) ? props.controlValue : "";
    const inputParam_ShowLabel = !isNullUndefinedOrEmpty(props.showLabel) ? props.showLabel : true;
    const inputParam_SetterControlValue = !isNullUndefined(props.setterControlValue) ? props.setterControlValue : null;
    const inputParam_SetterIsDynamic = !isNullUndefinedOrEmpty(props.setterControlIsDynamic) ? props.setterControlIsDynamic : false;
    const inputParam_SetterField = !isNullUndefinedOrEmpty(props.setterField) ? props.setterField : null;
    const inputParam_IsInvalirControl = !isNullUndefined(props.isInvalirControl) ? props.isInvalirControl : false;
    const inputParam_EditMode = !isNullUndefined(props.editMode) ? props.editMode : false;
    const inputParam_MaxLength = !isNullUndefined(props.maxLength) ? props.maxLength : 1200;
    const inputParam_ClassNameViewMode = !isNullUndefinedOrEmpty(props.classNameViewMode) ? props.classNameViewMode : "";
    const inputParam_Rows = !isNullUndefined(props.rows) ? props.rows : 16;
    
    //Parametros de componente.
    const [isInvalidControl, setIsInvalidControl] = useState(false);

    //Funciones de componente.
    const isInValidFormControl = (value) => {
        return value === "" ? true : false;
    }

    const checkIfIsInvalidControl = () => {
        const _isInvalidControl = isInvalidControl !== null ? isInvalidControl : false;
        const _inputParam_IsInvalirControl = inputParam_IsInvalirControl !== null ? inputParam_IsInvalirControl : false;

        return _isInvalidControl === true | _inputParam_IsInvalirControl === true ? true : false;
    }

    //Eventos de componente.
    const onChangeValue = (value) => {
        setIsInvalidControl(isInValidFormControl(value));
        if (inputParam_SetterIsDynamic === false) {
            inputParam_SetterControlValue && inputParam_SetterControlValue(value);
        }
        else {
            if (inputParam_SetterField !== null) {
                inputParam_SetterControlValue && inputParam_SetterControlValue(value, inputParam_SetterField);
            }
            else {
                inputParam_SetterControlValue && inputParam_SetterControlValue(value);
            }
        }
    };

    //Render de componente.
    return (
        <>
        {
            <>
                {
                    inputParam_ShowLabel &&
                    <b><Form.Label className="pe-2">{ inputParam_LabelText }:</Form.Label></b>
                }
                {
                    inputParam_EditMode &&
                    <>
                        <TextField 
                            autoAdjustHeight
                            maxLength={inputParam_MaxLength}
                            resizable
                            default
                            rows={inputParam_Rows}
                            value={ inputParam_ControlValue }
                            multiline 
                            onChange={onChangeValue}
                        />
                        <CValidator isInValid={ checkIfIsInvalidControl() } />
                    </>
                }
                {
                    !inputParam_EditMode &&
                    <>
                        <div style={{backgroundColor: '#f3f2f1'}} className={"body-content " + inputParam_ClassNameViewMode} dangerouslySetInnerHTML={{__html: inputParam_ControlValue}}></div>
                    </>
                }
            </>
        }
        </>
    );
}

export default CTextAreaSimple;